const httpsUrl = (v: unknown): string | null => {
    if (typeof v !== "string" || !v) return null;
    try {
        return new URL(v).protocol === "https:" ? v : null;
    } catch {
        return null;
    }
};

/**
 * The photo players and the portal show for a coach: their Swana app profile
 * picture (`users/{uid}.profilePicture`), read live so a change in the app shows
 * everywhere, else the one stored on the coach doc at setup, else null (initials).
 */
export function coachPhotoUrl(user: unknown, stored: string | null): string | null {
    const appPhoto = typeof user === "object" && user !== null ? (user as { profilePicture?: unknown }).profilePicture : undefined;
    return httpsUrl(appPhoto) ?? httpsUrl(stored);
}
